import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { HomeRoutingModule } from './home-routing.module';
import { SharedModule } from '../shared/shared.module';
import { OfferService } from '../offer/offer.service';
import { SwiperModule } from 'swiper/angular';
import { VideoModule } from '../video/video.module';
import { HeroSliderModule } from '../shared/helpers/hero-slider.module';

@NgModule({
  imports: [HomeRoutingModule, SharedModule, SwiperModule, VideoModule, HeroSliderModule],
  declarations: [HomeComponent],
  exports: [HomeComponent],
  providers: [OfferService]
})
export class HomeModule { }
